export type CardKey = 'work' | 'interview' | 'beginner' | 'pro' | 'common';
export interface Card {
  key: CardKey;
  titleKey: string;
  descriptionKey: string;
  pointKeys: string[];
  badgeKeys: string[];
}
export const CARDS: Card[] = [{
  key: 'work',
  titleKey: 'cards.work.title',
  descriptionKey: 'cards.work.description',
  pointKeys: ['cards.work.points.0', 'cards.work.points.1', 'cards.work.points.2'],
  badgeKeys: ['cards.work.badges.0']
}, {
  key: 'interview',
  titleKey: 'cards.interview.title',
  descriptionKey: 'cards.interview.description',
  pointKeys: ['cards.interview.points.0', 'cards.interview.points.1', 'cards.interview.points.2'],
  badgeKeys: ['cards.interview.badges.0', 'cards.interview.badges.1']
}, {
  key: 'beginner',
  titleKey: 'cards.beginner.title',
  descriptionKey: 'cards.beginner.description',
  pointKeys: ['cards.beginner.points.0', 'cards.beginner.points.1', 'cards.beginner.points.2'],
  badgeKeys: ['cards.beginner.badges.0', 'cards.beginner.badges.1']
}, {
  key: 'pro',
  titleKey: 'cards.pro.title',
  descriptionKey: 'cards.pro.description',
  pointKeys: ['cards.pro.points.0', 'cards.pro.points.1', 'cards.pro.points.2'],
  badgeKeys: ['cards.pro.badges.0']
}, {
  key: 'common',
  titleKey: 'cards.common.title',
  descriptionKey: 'cards.common.description',
  pointKeys: ['cards.common.points.0', 'cards.common.points.1', 'cards.common.points.2'],
  badgeKeys: ['cards.common.badges.0', 'cards.common.badges.1']
}];